
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from "react-bootstrap"
import { ReactComponent as CameraPermissionGraphic } from '../../icon/camera-permission.svg'
import BobbingIcon from '../common/BobbingIcon'
import "../../css/Modal.css"

interface PermissionModalProps {
  show: boolean
}

function PermissionModal({ show }: PermissionModalProps) {
  const { t } = useTranslation()

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Body className="p-4">
        <BobbingIcon horizontalOffset="-58px" verticalOffset="-30px">
          <CameraPermissionGraphic />
        </BobbingIcon>
        <h1>{t("cameraPermission.heading")}</h1>
        <p>{t("cameraPermission.text")}</p>
      </Modal.Body>
    </Modal>
  )
}

export default PermissionModal
